import { useField } from "formik";
import { InputHTMLAttributes } from "react";
import styles from "./SelectField.module.scss";

type Option = {
  value: string;
  label: string;
};

interface Props extends InputHTMLAttributes<HTMLSelectElement> {
  name: string;
  options: Option[] | string[];
  label?: string;
  showValueSelected?: boolean;
  dark?: boolean;
  darkest?: boolean;
}

// form input that connects to a formik form
const SelectField: React.FC<Props> = ({
  name,
  label,
  options,
  showValueSelected,
  dark,
  darkest,
  ...rest
}) => {
  const [field, _meta, _helpers] = useField(name);
  return (
    <div className={styles.container}>
      <select
        data-testid={`select-${name}`}
        // TODO: this darker variant can reference a css variable
        style={
          darkest
            ? { background: "#050505" }
            : dark
            ? { background: "#171717" }
            : undefined
        }
        className={styles.input}
        aria-label={label}
        {...field}
        {...rest}
      >
        {label && <option>{label}</option>}
        {showValueSelected && (
          <option value={field.value} hidden>
            {field.value}
          </option>
        )}
        {options.map((option, i) =>
          typeof option === "string" ? (
            <option key={`${i}-${option}`} value={option}>
              {option}
            </option>
          ) : (
            <option key={`${i}-${option.value}`} value={option.value}>
              {option.label}
            </option>
          ),
        )}
      </select>
      <i className="fas fa-chevron-down" />
    </div>
  );
};

export default SelectField;
